// @flow

import {unsafelyParseMarkdown, Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

function parseMarkdown(string, config) {
  const tag = unsafelyParseMarkdown(string, config);
  return !tag || typeof tag === 'string' || Array.isArray(tag)
    ? ''
    : tag.children;
}

export const BalanceTransactionTable: MarkdocTagRegistration = {
  tag: 'balance-transaction-table',
  component: 'BalanceTransactionTable',
  attributes: {
    balanceTransactionGroups: {
      type: Array,
      description: 'List of balance transaction group objects.',
    },
    balanceTransactionsMap: {
      type: Object,
      description:
        'Object mapping from balance transaction group name to list of balance transaction objects',
    },
  },
  render(node, config) {
    const children = node.renderChildren(config);
    const attributes = node.renderAttributes(this.attributes, config);
    const {balanceTransactionGroups, balanceTransactionsMap} = attributes;

    if (balanceTransactionGroups) {
      balanceTransactionGroups.forEach((group) => {
        group.description = parseMarkdown(group.description, config);
      });

      attributes.balanceTransactionGroups = balanceTransactionGroups;
    }

    if (balanceTransactionsMap) {
      Object.keys(balanceTransactionsMap).forEach((groupID) => {
        const btInGroup = balanceTransactionsMap[groupID];
        if (!btInGroup) {
          // Make sure that the balance transaction group is declared
          // in the context
          throw new Error(`Balance transaction group not found: ${groupID}`);
        }

        btInGroup.forEach((balanceTransaction) => {
          balanceTransaction.description = parseMarkdown(
            balanceTransaction.description,
            config,
          );
        });
      });

      attributes.balanceTransactionsMap = balanceTransactionsMap;
    }

    return new Tag(this.tag, attributes, children);
  },
};
